import { useState } from "react";
import { NavLink, Form } from "react-router-dom";

import logo from "../../../assets/dash-logo.svg";
import dashboardIcon from "../../../assets/dashboard-icon.svg";
import jobsIcon from "../../../assets/jobs-icon.svg";
import proffesionalsIcon from "../../../assets/proffesional-icon.svg";
import companiesIcon from "../../../assets/companies-icon.svg";
import adminIcon from "../../../assets/admins-icon.svg";

export default function DashboardNav() {
  const [isActive, setIsActive] = useState(false);

  const handleMenu = () => {
    setIsActive((prev) => !prev);
  };

  return (
    <>
      <div className="dashboard-nav-wrapper">
        <div className="dashboard-nav-wrapper__logo">
          <img src={logo} alt="logo" />
        </div>
        <div
          className={`${isActive ? "active" : ""} dashboard-nav-wrapper__nav`}
        >
          <NavLink
            className={({ isActive }) => (isActive ? "active" : "")}
            to="/admin/dashboard"
            onClick={handleMenu}
          >
            <img src={dashboardIcon} alt="dash icon" />
            Dashboard
          </NavLink>
          <NavLink
            className={({ isActive }) => (isActive ? "active" : "")}
            to="/admin/jobs"
            onClick={handleMenu}
          >
            <img src={jobsIcon} alt="jobs icon" />
            Jobs
          </NavLink>
          <NavLink
            className={({ isActive }) => (isActive ? "active" : "")}
            to="/admin/candidates"
            onClick={handleMenu}
          >
            <img src={proffesionalsIcon} alt="proffesionals icon" />
            Candidates
          </NavLink>
          <NavLink
            className={({ isActive }) => (isActive ? "active" : "")}
            to="/admin/companies"
            onClick={handleMenu}
          >
            <img src={companiesIcon} alt="companies icon" />
            Companies
          </NavLink>
          <NavLink
            className={({ isActive }) => (isActive ? "active" : "")}
            to="/admin/admins"
            onClick={handleMenu}
          >
            <img src={adminIcon} alt="admin icon" />
            Admins
          </NavLink>
          <Form action="/admin/logout" method="post">
            <button type="submit" className="dashboard-logout">
              Logout
            </button>
          </Form>
        </div>
        <div className="dashboard-nav-wrapper__hamburger" onClick={handleMenu}>
          <span className="line-1"></span>
          <span className="line-2"></span>
        </div>
      </div>
    </>
  );
}
